import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
//import { NotificationBarService } from '../notification-bar/notification-bar.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMessage = this.handleError(error);
          return throwError(errorMessage);
        })
      )
  };

  private handleError(error: HttpErrorResponse): string {
    if (error.status === 404) {
      return this.handleNotFound(error);
    }
    else if (error.status === 400) {
      return this.handleBadRequest(error);
    }
    else if (error.status === 401) {
      return this.handleUnauthorized(error);
    }
    else if (error.status === 403) {
      return this.handleForbidden(error);
    }
  }

  private handleNotFound(error: HttpErrorResponse): string {
    //this.router.navigate(['/404']);
    return error.message;
  }

  private handleBadRequest(error: HttpErrorResponse): string {
    if (error.error.errors) {
      let message = '';
      const values = Object.values(error.error.errors);
      values.map((m: string) => {
        message += m + '<br>';
      })
      return message.slice(0, -4);
    }
    else {
      return error.error;
    }

  }

  private handleUnauthorized(error: HttpErrorResponse) {
    if (this.router.url.startsWith('/auth/login')) {
      return error.error.errorMessage;
    }
    else {
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: this.router.url } });
      return error.message;
    }
  }

  private handleForbidden = (error: HttpErrorResponse) => {
    this.router.navigate(["/auth/login"], { queryParams: { returnUrl: "/", message: "" } });
    return "Forbidden";
  }
}
